<script>
import BaseTab from "@/components/BaseTab.vue";
import ProfileNewsList from "@/views/profile/ProfileNewsList.vue";
import ProfileOpinionsList from "@/views/profile/ProfileOpinionsList.vue";
import ProfileProposalsList from "@/views/profile/ProfileProposalsList.vue";
import i18n from "@/i18n";
import ProfileCriticalEvents from "@/views/profile/ProfileCriticalEvents.vue";
import {CreatorType} from "@/store/model/ImgLabel";
import ProfileFollows from "@/views/profile/ProfileFollows.vue";

export default {
  name: "ProfileContentInfo",
  components: {
    ProfileFollows,
    ProfileCriticalEvents,
    BaseTab,
    ProfileNewsList,
    ProfileOpinionsList,
    ProfileProposalsList
  },
  props: {
    isOwnProfile: {
      type: Boolean,
      default: false
    },
    accountId: {
      type: Number
    }
  },
  data() {
    return {
      activeTab: {},
    }
  },
  computed: {
    CreatorType() {
      return CreatorType
    },
    tabs() {
      const tabs = [
        {
          label: this.isOwnProfile
              ? i18n.global.t('profile.tabs.criticalEvents')
              : i18n.global.t('profile.tabs.news'),
          code: 'NEWS',
        },
        {
          label: i18n.global.t('profile.tabs.opinions'),
          code: 'OPINIONS',
        },
        {
          label: i18n.global.t('profile.tabs.proposals'),
          code: 'PROPOSALS',
        },
      ];
      if (this.isOwnProfile) {
        tabs.push(
            {
              label: i18n.global.t('profile.tabs.follows'),
              code: 'FOLLOWS',
            }
        );
      }
      return tabs;
    }
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
    },
  },
  mounted() {
    this.activeTab = this.tabs[0];
  },
}
</script>

<template>
<div class="profile-content-info-wrap">
  <div class="profile-content-info">
    <div class="profile-content-tabs">
      <base-tab v-for="tab in tabs"
                :key="tab.code"
                :label="tab.label"
                :active="tab.code === activeTab.code"
                @click="setActiveTab(tab)"
      ></base-tab>
    </div>
    <div class="profile-content-main">
      <div v-show="activeTab.code === 'NEWS'">
        <profile-critical-events v-if="isOwnProfile" :entity-id="accountId" :entity-type="CreatorType.USER"/>
        <profile-news-list v-else/>
      </div>
      <div v-if="activeTab.code === 'OPINIONS'">
        <profile-opinions-list :is-own-profile="isOwnProfile"/>
      </div>
      <div v-if="activeTab.code === 'PROPOSALS'">
        <profile-proposals-list :is-own-profile="isOwnProfile"/>
      </div>
      <div v-show="activeTab.code === 'FOLLOWS'">
        <profile-follows v-if="isOwnProfile" :user-id="accountId"/>
      </div>
    </div>
  </div>
</div>
</template>

<style lang="scss">
.profile-content-info-wrap {
  width: 600px;
}

.profile-content-info {
  .profile-content-tabs {
    display: flex;
    height: 36px;
    border-bottom: 1px solid #ddd;
    box-shadow: 0 1px 1px #ddd;
    white-space: nowrap;
    background: #fff;
    .base-tab {
      width: auto;
      padding: 0 15px;
    }
  }
}
</style>